import React, {useEffect} from "react";
import { makeStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from 'react-redux';
import '@fontsource/roboto';

import * as actions from './store/actions/auth';

import './App.css';

/* import Main from './containers/Main';
import SignUp from './containers/SignUp';
import NotFound from './containers/NotFound';
*/
// import Layout from './containers/Layout';

 import { Route } from 'react-router-dom';

import Main from './containers/Main';
import Posts from './containers/Posts';
import Post from './containers/Post';
//import LogIn from './containers/LogIn';
//import SignUp from './containers/SignUp';
import MTurkSignUp from './containers/MTurkSignUp';
import Instruction from './containers/Instruction';
import InformedConsent from './containers/InformedConsent';
import End from './containers/End';
import PreSurvey from "./containers/PreSurvey";
import PreReadingSurvey from "./containers/PreReadingSurvey";
import PostReadingSurvey from "./containers/PostReadingSurvey";
import PostSurvey from "./containers/PostSurvey";
/* import InformedConsent from "./containers/InformedConsent";
import Instruction from "./containers/Instruction";
import ChangeNickname from "./containers/ChangeNickname";
 */

//import SignUp from './containers/SignUp';

import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';


const useStyles = makeStyles((theme) => ({
  root: {
      flexGrow: 1,
    },
    layout:{
      backgroundColor: 'ghostwhite',
      minHeight: '100vh'
    },
    content:{
      minHeight: '95vh',
      padding: '5vh',
      maxWidth: '960px',
      margin: 'auto'
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 0,
    },
    topnav:{
        minHeight: '5vh',
        maxHeight: '50px',
        padding: '10px',
        paddingLeft: '20px',
        backgroundColor: '#purple',
        boxShadow: '0 0 0 0'
    },
    footer:{
      textAlign: 'center',
      backgroundColor: '#white',
      color: '#white',
      height: '5vh',
      maxWidth: 'none'}

}));

function App(props){
  const classes=useStyles();

  useEffect(()=>{
    props.onTryAutoSignup();

  },)

  

  return (
    <div className={classes.layout}>
      <AppBar position="static" className={classes.topnav}>
        <Typography variant="h6" className={classes.title}>
            User-Generated Labels  
            { props.isAuthenticated ?
                <span style={{paddingLeft: '10px'}}>
                (username: {props.username})
                </span>
                :
                null
            }
        </Typography>                    
    </AppBar>
    <Container className={classes.content}>
        <Router>
          <Route exact path='/'> <Posts /> </Route> 
          <Route exact path='/main/'> <Posts /> </Route> 
          <Route exact path='/posts/'> <Posts /> </Route> 
          <Route exact path='/end/' component={End} /> {" "} 
          <Route exact path="/post/:postno(\d+)/">
            <Post  displayname={props.displayname} username={props.username}/>
          </Route>
          <Route exact path='/instruction/:postno(\d+)/:condition(\w+)/' render={() => (<Instruction  />)} />       
          <Route exact path='/signup/' component={MTurkSignUp} /> {" "}
          <Route exact path='/informed-consent/' component={InformedConsent} /> {" "}  

          <Route exact path='/pre-survey/:postno(\d+)/:condition(\w+)/'render={() => (<PreSurvey  />)} />         
          <Route exact path='/post-reading-survey/:postno(\d+)/:condition(\w+)/' render={() => (<PostReadingSurvey />)} />  
          <Route exact path='/post-survey/:postno(\d+)/:condition(\w+)/' render={() => (<PostSurvey />)} />  
      </Router>  
    </Container>
      
    </div>
  );
}

const mapStateToProps = state =>{
  return {
    isAuthenticated: state.token !== null, 
    username: state.username, 
    displayname: state.displayname,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    logout: () => dispatch(actions.authLogout()) 
  }
}



export default 
  connect(
    mapStateToProps,
    mapDispatchToProps, // or put null here if you do not have actions to dispatch
  )(App);
